import CitySEOHead from "@/components/feature/CitySEOHead";
import EaganHeroSection from "./components/HeroSection";
import EaganStickyNav from "./components/StickyNav";
import EaganProcessingTimeSection from "./components/ProcessingTimeSection";
import EaganServicesSection from "./components/ServicesSection";
import EaganLocalAreaSection from "./components/LocalAreaSection";
import EaganTravelTimingSection from "./components/TravelTimingSection";
import EaganDestinationsSection from "./components/DestinationsSection";
import EaganTestimonialsSection from "./components/TestimonialsSection";
import EaganAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import EaganComparisonSection from "./components/ComparisonSection";
import EaganMistakesSection from "./components/MistakesSection";
import EaganHowItWorksSection from "./components/HowItWorksSection";
import EaganFAQSection from "./components/FAQSection";
import EaganHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import EaganFinalCTA from "./components/FinalCTA";
import { faqs } from "./components/FAQSection";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function EaganPage() {
  return (
    <>
      <CitySEOHead
        city="Eagan"
        state="Minnesota"
        stateAbbr="MN"
        route="/cities/eagan"
        title="Emergency Passport Eagan, MN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Eagan, MN — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Thomson Reuters, Blue Cross Blue Shield, Cedar Grove families, and all of Dakota County south metro."
        geoPlacename="Eagan, Minnesota"
        geoPosition="44.8041;-93.1669"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Minnesota"
        statePageRoute="/states/minnesota"
        keywords="expedited passport Eagan MN, emergency passport Eagan, passport renewal Dakota County"
      />
      <div className="font-sans">
        <EaganHeroSection />
        <EaganStickyNav />
        <EaganProcessingTimeSection />
        <EaganLocalAreaSection />
        <EaganServicesSection />
        <EaganTravelTimingSection />
        <EaganDestinationsSection />
        <EaganTestimonialsSection />
        <EaganAcceptanceFacilitiesSection />
        <EaganComparisonSection />
        <EaganMistakesSection />
        <EaganHowItWorksSection />
        <EaganFAQSection />
        <EaganHelpfulResourcesSection />
        <EaganFinalCTA />
      </div>
    </>
  );
}